// extracted by mini-css-extract-plugin
export default {"locationDropdown":"AssignSupportStaffModal_locationDropdown__sCboW"};